import React from "react";
import cn from "classnames";
import { COMPANY } from "../../content/siteContent";

export const ContactNumbers = ({
  className,
  showLabels = true,
  includeWhatsApp = true,
  includePhones = true,
}) => {
  const contacts = [
    ...(includeWhatsApp
      ? COMPANY.whatsappNumbers
          .filter((item) => item.type === "whatsapp")
          .map((wa) => ({
            ...wa,
            label: "WhatsApp",
          }))
      : []),
    ...(includePhones
      ? [
          ...COMPANY.phones.map((phone) => ({ ...phone, type: "phone", label: "Call" })),
          ...COMPANY.whatsappNumbers
            .filter((item) => item.type === "call")
            .map((call) => ({
              ...call,
              label: "Call",
            })),
        ]
      : []),
  ];

  return (
    <ul className={cn("contact-number-list list-wrap", className)}>
      {contacts.map((contact) => (
        <li key={`${contact.type}-${contact.number}`}>
          <a href={contact.href}>
            <i
              className={
                contact.type === "whatsapp"
                  ? "fab fa-whatsapp"
                  : "flaticon-phone-call"
              }
            ></i>
            <span>
              {showLabels ? <strong>{contact.label}: </strong> : null}
              {contact.number}
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
};
